<div class="rounded-lg border border-gray-200 bg-gray-50 p-4 dark:border-gray-700 dark:bg-gray-900/40">
  <div class="mb-3 flex items-center justify-between gap-3">
    <h4 class="text-sm font-semibold text-gray-900 dark:text-white">Congelamiento {{ modelo.nombre }}</h4>
    @if (modelo.salida && canDelete) {
      <app-delete-trigger
        [title]="'Eliminar producción de embriones ' + modelo.nombre"
        [subtitle]="'¿Confirma eliminar la producción de embriones? Esta acción no se puede deshacer.'"
        [disabled]="deshabilitado"
        (clickDeleteEvent)="eliminar.emit()"
      />
    }
  </div>

  <!-- Issue #15 (2026-09-15): el descarte del día 8 ya no bloquea la
       producción de embriones. Si se repone la regla, reponer también
       `puedeRegistrarSalida` en el componente.
  @if (!modelo.puedeRegistrarSalida) {
    <div class="mb-4 rounded-md border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-800 dark:border-amber-800 dark:bg-amber-950 dark:text-amber-300">
      El cultivo tiene registrado el descarte del día 8: el ciclo está cerrado y ya no puede registrar producción de embriones.
    </div>
  }
  -->

  <app-form [formGroup]="modelo.form">
    <!-- <div class="grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-4 mb-5"> -->
    <div class="grid grid-cols-1 gap-3 md:grid-cols-2 mb-5" [class.lg:grid-cols-4]="!controlForm" [class.lg:grid-cols-6]="!!controlForm">
      <!-- AM7/PM7: estadio y grado se cargan acá, junto con la producción, pero
           se guardan en el control del día (no en la producción). -->
      @if (controlForm) {
        <div [formGroup]="controlForm">
          <app-label [for]="'estadio-' + modelo.etiqueta">Estadio</app-label>
          <app-select [id]="'estadio-' + modelo.etiqueta" formControlName="param_estadio_embrionario_id" [options]="estadiosOptions" [allowEmpty]="true"
            [error]="controlForm.get('param_estadio_embrionario_id')!.invalid && controlForm.get('param_estadio_embrionario_id')!.touched" />
        </div>
        <div [formGroup]="controlForm">
          <app-label [for]="'grado-' + modelo.etiqueta">Grado</app-label>
          <app-input-field [id]="'grado-' + modelo.etiqueta" formControlName="grado" type="number" [min]="1" [step]="1"
            [error]="controlForm.get('grado')!.invalid && controlForm.get('grado')!.touched" />
        </div>
      }
      <div>
        <app-label [for]="'fecha_salida-' + modelo.etiqueta">
          Fecha de producción de embriones
        </app-label>
        <app-input-field [id]="'fecha_salida-' + modelo.etiqueta" formControlName="fecha_salida" type="date" />
      </div>

      <div>
        <app-label [for]="'nro_embriones-' + modelo.etiqueta">
          Totales
        </app-label>
        <app-input-field [id]="'nro_embriones-' + modelo.etiqueta" formControlName="nro_embriones" type="number" />
      </div>

      <div>
        <app-label [for]="'descarte-' + modelo.etiqueta">
          Descarte
        </app-label>
        <app-input-field [id]="'descarte-' + modelo.etiqueta" formControlName="descarte" type="number" />
      </div>

      @if (modelo.motivoSalidaInvalida) {
        <div class="lg:col-span-4 rounded-md border border-red-300 bg-red-50 px-4 py-3 text-sm text-red-700 dark:border-red-800 dark:bg-red-950 dark:text-red-300">
          {{ modelo.motivoSalidaInvalida }}
        </div>
      }

      @if (modelo.isCongelada) {
        @if (modelo.motivoNoCongelable) {
          <div class="lg:col-span-4 rounded-md border border-red-300 bg-red-50 px-4 py-3 text-sm text-red-700 dark:border-red-800 dark:bg-red-950 dark:text-red-300">
            {{ modelo.motivoNoCongelable }}
          </div>
        }

        <div>
          <app-label [for]="'param_tecnica_congelamiento_id-' + modelo.etiqueta">
            Técnica congelamiento
          </app-label>
          <app-select [id]="'param_tecnica_congelamiento_id-' + modelo.etiqueta" formControlName="param_tecnica_congelamiento_id" placeholder="Seleccione una técnica" [options]="tecnicasCongelamientoOptions" />
        </div>

        <!-- Issue #20 (2026-09-15): el raque se escribe a mano, ya no sale
             de un paramétrico. -->
        <div>
          <app-label [for]="'raque-' + modelo.etiqueta">
            Raque
          </app-label>
          <app-input-field [id]="'raque-' + modelo.etiqueta" formControlName="raque" placeholder="Ej. Raque 1" />
        </div>

        <div class="lg:col-span-4">
          <app-label>
            Distribución de embriones por pajuela
          </app-label>

          @if (modelo.distribucionPajuelas.length > 0) {
            <div class="flex flex-wrap gap-3">
              @for (pajuela of modelo.distribucionPajuelas; track $index) {
                <div class="w-56 rounded-lg border border-gray-200 p-3 dark:border-gray-700">
                  <!-- <span class="mb-2 block text-xs font-medium text-gray-500 dark:text-gray-400">Pajuela #{{ $index + 1 }}</span> -->
                  <!-- Vitrificado: cada tarjeta es una OPS. Direct Transfer sigue hablando de pajuelas. -->
                  <div class="mb-2 flex items-center justify-between">
                    <span class="text-xs font-medium text-gray-500 dark:text-gray-400">{{ modelo.isTecnicaDT ? 'Pajuela' : 'OPS' }} #{{ $index + 1 }}</span>
                    @if (modelo.distribucionEditable && modelo.distribucionPajuelas.length > 1) {
                      <button type="button" class="text-xs text-red-600 hover:underline dark:text-red-400"
                        [attr.aria-label]="'Quitar OPS ' + ($index + 1) + ' ' + modelo.nombre" (click)="modelo.quitarOps($index)">Quitar</button>
                    }
                  </div>

                  <span class="mb-1 block text-xs text-gray-500 dark:text-gray-400">Embriones</span>
                  <input
                    type="number"
                    min="1"
                    max="6"
                    [attr.aria-label]="'Embriones ' + modelo.etiqueta + ' pajuela ' + ($index + 1)"
                    [value]="pajuela.nro_embriones"
                    [disabled]="!modelo.distribucionEditable"
                    (input)="modelo.actualizarPajuela($index, $any($event.target).value)"
                    class="w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 disabled:bg-gray-100 dark:border-gray-700 dark:bg-gray-800 dark:text-white dark:disabled:bg-gray-900"
                  />

                  <!-- Issue #19 (2026-09-15): la pajuela Direct Transfer viene
                       rotulada de fábrica: se copia ese ID y no se marca OPS. -->
                  @if (modelo.isTecnicaDT) {
                    <span class="mt-2 mb-1 block text-xs text-gray-500 dark:text-gray-400">ID de la pajuela</span>
                    <input
                      type="text"
                      maxlength="50"
                      [attr.aria-label]="'ID ' + modelo.etiqueta + ' pajuela ' + ($index + 1)"
                      [value]="pajuela.identificador ?? ''"
                      [disabled]="modelo.readOnly"
                      (input)="modelo.actualizarIdentificadorPajuela($index, $any($event.target).value)"
                      class="w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 disabled:bg-gray-100 dark:border-gray-700 dark:bg-gray-800 dark:text-white dark:disabled:bg-gray-900"
                    />
                  } @else {
                    <span class="mt-2 mb-1 block text-xs text-gray-500 dark:text-gray-400">Punto de OPS</span>
                    <select
                      [attr.aria-label]="'Punto de OPS ' + modelo.etiqueta + ' pajuela ' + ($index + 1)"
                      [value]="pajuela.param_ops_punto_id ?? ''"
                      [disabled]="modelo.readOnly"
                      (change)="modelo.actualizarOpsPajuela($index, 'param_ops_punto_id', $any($event.target).value)"
                      class="w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 disabled:bg-gray-100 dark:border-gray-700 dark:bg-gray-800 dark:text-white dark:disabled:bg-gray-900"
                    >
                      <option value="">Punto</option>
                      @for (opcion of opsPuntosOptions; track opcion.value) {
                        <option [value]="opcion.value">{{ opcion.label }}</option>
                      }
                    </select>

                    <span class="mt-2 mb-1 block text-xs text-gray-500 dark:text-gray-400">Color de OPS</span>
                    <select
                      [attr.aria-label]="'Color de OPS ' + modelo.etiqueta + ' pajuela ' + ($index + 1)"
                      [value]="pajuela.param_ops_color_id ?? ''"
                      [disabled]="modelo.readOnly"
                      (change)="modelo.actualizarOpsPajuela($index, 'param_ops_color_id', $any($event.target).value)"
                      class="w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 disabled:bg-gray-100 dark:border-gray-700 dark:bg-gray-800 dark:text-white dark:disabled:bg-gray-900"
                    >
                      <option value="">Color</option>
                      @for (opcion of opsColoresOptions; track opcion.value) {
                        <option [value]="opcion.value">{{ opcion.label }}</option>
                      }
                    </select>
                  }
                </div>
              }
              @if (modelo.puedeAgregarOps) {
                <button type="button" class="flex w-56 items-center justify-center rounded-lg border border-dashed border-gray-300 p-3 text-sm font-medium text-gray-600 hover:bg-white dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800"
                  (click)="modelo.agregarOps()">+ Agregar OPS</button>
              }
            </div>

            <p class="mt-2 text-xs" [class.text-red-500]="!modelo.distribucionValida" [class.text-gray-500]="modelo.distribucionValida">
              Suma: {{ modelo.sumaDistribucion }} / {{ modelo.form.controls.nro_embriones.value || 0 }} embriones · {{ modelo.distribucionPajuelas.length }} {{ modelo.isTecnicaDT ? 'pajuela(s)' : 'OPS' }}
              @if (modelo.isTecnicaDT) {
                · Direct Transfer: 1 embrión por pajuela
              }
              @if (modelo.distribucionTieneTrazabilidad) {
                · No editable: el stock ya tiene pajuelas consumidas o reservadas
              }
              @if (!modelo.distribucionOpsCompleta) {
                @if (modelo.isTecnicaDT) {
                  · Falta cargar el ID de cada pajuela
                } @else {
                  · Falta cargar el punto y el color de OPS de cada pajuela
                }
              }
            </p>
          } @else {
            <p class="text-xs text-gray-500 dark:text-gray-400">
              Ingrese el número de embriones para calcular las pajuelas.
            </p>
          }
        </div>
      }

      <!-- Sin observación para ahorrar espacio: el valor guardado se conserva al editar.
      <div class="lg:col-span-4">
        <app-label [for]="'observacion_salida-' + modelo.etiqueta">
          Observación de producción de embriones
        </app-label>
        <app-textarea [id]="'observacion_salida-' + modelo.etiqueta" formControlName="observacion" [rows]="3" />
      </div>
      -->
    </div>
  </app-form>

  @if (modelo.salida?.stock_vitrificado; as stockVitrificado) {
    <div class="mb-4 rounded-lg border border-gray-200 px-4 py-3 text-sm text-gray-600 dark:border-gray-700 dark:text-gray-300">
      Stock congelado generado: #{{ stockVitrificado.id }}
      - {{ stockVitrificado.nro_embriones }} embriones
    </div>
  }
  @if (modelo.error) { <p role="alert" class="mt-2 text-sm text-red-600">{{ modelo.error }}</p> }
</div>
